module.exports = __webpack_public_path__ + "img/zero-logo-light.216d872d.svg";